module.exports = __webpack_public_path__ + "static/media/XAUT.41a8828d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/components/CoinCircle/icons/XAUT.svg
// module id = 1517
// module chunks = 85